import { track } from './core';

export function trackIntegrationsAddAppClicked() {
  track('integrations_add_app_clicked');
}

export function trackIntegrationsAppOpened(appId, appName) {
  track('integrations_app_opened', { app_id: appId, app_name: appName });
}

export function trackIntegrationsReportDownloaded(appId, appName) {
  track('integrations_report_downloaded', { app_id: appId, app_name: appName });
}

export function trackIntegrationsLinkCopied(appId, appName) {
  track('integrations_link_copied', { app_id: appId, app_name: appName });
}

export function trackIntegrationsAppDeleted(appId, appName) {
  track('integrations_app_deleted', { app_id: appId, app_name: appName });
}

export function trackIntegrationsAppDeleteFailed(appId, appName, error) {
  track('integrations_app_delete_failed', { app_id: appId, app_name: appName, error });
}

export function trackIntegrationsHelpClicked() {
  track('integrations_help_clicked');
}
